<template>
  <div class="forgot-password fullWidth">
    <div class="card">
      <div class="card-body">
        <div>
          <vue-form
            ref="form"
            :options="{
              permalink: 'forgotPasswordEmail'
            }">
          </vue-form>
        </div>
        <br/>
        <router-link :to="{ path : '/' }" class="btn btn-secondary btn-sm"><i class="fa fa-arrow-left"></i> Back to Login </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import VueForm from '@/components/Form.vue'

export default {
  name: 'ForgotPassword',
  components: {
    VueForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue